/*@ngInject*/
const LoadTaskRepository = function (baseRepository, coreMediator) {
    let translationTable = {
        insuredName: 's.insured.name',
        assignedToName: 't.assignedTo.name',
        assignedByName: 't.assignedBy.name',
        productShortNames: 's.productShortNames',
        effectiveDate: 's.effectiveDate',
        dueDate: 't.dueDate',
        priority: 't.priority',
        resolutionDate: 't.resolutionDate'
    };

    angular.extend(this, baseRepository);

    this.loadTasks = function (taskParams) {
        let url = '/rest/SubmissionTask/filter',
            sortColumn = translationTable[taskParams.key] || taskParams.key,
            config = {
                params: {
                    filterUri: taskParams.filterUri,
                    resultType: 'grid',
                    startIndex: taskParams.startIndex,
                    numberOfRows: taskParams.pageSize,
                    sortBy: sortColumn + ' ' + taskParams.sortType
                }
            };

        return this.get(url, config);
    };

    this.getDownloadUrl = function(requestParams) {
        return coreMediator.getSingleUseToken().then((token) => {
            return `/tasks/tasks.csv?filterUri=${requestParams.filterUri}&t=${encodeURIComponent(token)}`;
        });
    };
};

angular.module('umLanding')
    .service('loadTaskRepository', LoadTaskRepository);
